module.exports = __webpack_public_path__ + "img/chambre2.a6ecd42e.jpg";